var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', [_c('sub-visual', {
    attrs: {
      "subTab": "",
      "sh": "About us",
      "index": "02",
      "total": "04",
      "tabActive": "Certificate",
      "bg": "/images/sub/visual/sv1.jpg"
    }
  }), _c('section', {
    staticClass: "section section--first section--last"
  }, [_c('v-container', [_c('div', {
    staticClass: "tit-wrap"
  }, [_c('h2', {
    staticClass: "tit tit--lg dot-tit"
  }, [_vm._v("Certificate")])]), _c('v-card', {
    attrs: {
      "tile": "",
      "elevation": "0",
      "color": "grey-f7"
    }
  }, [_c('v-divider', {
    staticClass: "primary border-8"
  }), _c('div', {
    staticClass: "px-20 py-30 px-md-30 py-lg-80"
  }, [_c('v-row', {
    staticClass: "row--large",
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "auto"
    }
  }, [_c('v-hover', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var hover = _ref.hover;
        return [_c('v-card', {
          staticClass: "min-w-md-300px w-lg-424px cursor-pointer",
          attrs: {
            "tile": "",
            "elevation": "0"
          },
          on: {
            "click": function click($event) {
              _vm.dialog = true;
            }
          }
        }, [_c('v-img', {
          staticStyle: {
            "position": "relative"
          },
          attrs: {
            "contain": "",
            "aspect-ratio": 424 / 600,
            "src": "/images/sub/aboutus/certificate-iso9001.jpg"
          }
        }, [_c('v-fade-transition', [hover ? _c('v-overlay', {
          attrs: {
            "absolute": ""
          }
        }, [_c('v-img', {
          attrs: {
            "width": "60",
            "src": "/images/icon/icon-plus-rounded.png"
          }
        })], 1) : _vm._e()], 1)], 1)], 1)];
      }
    }])
  }), _c('v-dialog', {
    attrs: {
      "content-class": "elevation-0"
    },
    model: {
      value: _vm.dialog,
      callback: function callback($$v) {
        _vm.dialog = $$v;
      },
      expression: "dialog"
    }
  }, [_c('v-container', {
    staticClass: "container--large"
  }, [_c('div', {
    staticClass: "text-right"
  }, [_c('v-btn', {
    staticClass: "transparent mr-n12",
    attrs: {
      "x-large": "",
      "icon": "",
      "color": "white"
    },
    on: {
      "click": function click($event) {
        _vm.dialog = false;
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-close")])], 1)], 1), _c('div', {
    staticClass: "mw-400px mw-lg-500px w-lg-424px mx-auto"
  }, [_c('v-img', {
    attrs: {
      "aspect-ratio": 424 / 600,
      "src": "/images/sub/aboutus/certificate-iso9001.jpg"
    }
  })], 1)])], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "auto"
    }
  }, [_c('v-hover', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref2) {
        var hover = _ref2.hover;
        return [_c('v-card', {
          staticClass: "min-w-md-300px w-lg-424px cursor-pointer",
          attrs: {
            "tile": "",
            "elevation": "0"
          },
          on: {
            "click": function click($event) {
              _vm.dialog2 = true;
            }
          }
        }, [_c('v-img', {
          staticStyle: {
            "position": "relative"
          },
          attrs: {
            "contain": "",
            "aspect-ratio": 424 / 600,
            "src": "/images/sub/aboutus/certificate-iso14001.jpg"
          }
        }, [_c('v-fade-transition', [hover ? _c('v-overlay', {
          attrs: {
            "absolute": ""
          }
        }, [_c('v-img', {
          attrs: {
            "width": "60",
            "src": "/images/icon/icon-plus-rounded.png"
          }
        })], 1) : _vm._e()], 1)], 1)], 1)];
      }
    }])
  }), _c('v-dialog', {
    attrs: {
      "content-class": "elevation-0"
    },
    model: {
      value: _vm.dialog2,
      callback: function callback($$v) {
        _vm.dialog2 = $$v;
      },
      expression: "dialog2"
    }
  }, [_c('v-container', {
    staticClass: "container--large"
  }, [_c('div', {
    staticClass: "text-right"
  }, [_c('v-btn', {
    staticClass: "transparent mr-n12",
    attrs: {
      "x-large": "",
      "icon": "",
      "color": "white"
    },
    on: {
      "click": function click($event) {
        _vm.dialog2 = false;
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-close")])], 1)], 1), _c('div', {
    staticClass: "mw-400px mw-lg-500px w-lg-424px mx-auto"
  }, [_c('v-img', {
    attrs: {
      "aspect-ratio": 424 / 600,
      "src": "/images/sub/aboutus/certificate-iso14001.jpg"
    }
  })], 1)])], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }